import React from 'react';
import './add questionnaire.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn,MDBIcon} from "mdbreact";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter,Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message ,DatePicker,TreeSelect} from "antd";
//import moment from "moment";
const {TreeNode} = TreeSelect;
class AddQuestionnaire extends React.Component {
    state = {
        name_en:"",
        name_ar:"",
        title_en:"",
        title_ar:"",
        description_ar:"",
        description_en:"",
        startDate:null,
        endDate:null,
        duration:1,
        type:"PUBLIC",
        answerType:null,
        options:[],
        inputCount:1,
        option_ar1:'',
        option_en1:'',
        option_ar2:'',
        option_en2:'',
        option_ar3:'',
        option_en3:'',
        option_ar4:'',
        option_en4:'',
        option_ar5:'',
        option_en5:'',
        option_ar6:'',
        option_en6:'',
       
    };

    constructor(props){
        super(props)
        window.scrollTo(0,0)
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }

    componentDidMount(){
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }
    /**
    * add request
    */
    add = () => {
        const {name_en,name_ar,description_ar,description_en,duration,startDate,endDate,
            answerType,type,option_ar1,option_ar2,option_ar3,option_ar4,option_ar5,option_ar6
        ,option_en1,option_en2,option_en3,option_en4,option_en5,option_en6,title_ar,title_en} = this.state
        let l = message.loading('Wait..', 2.5)
        if(type ==="PUBLIC" ){
            if(this.state.answerType ===null || startDate === null || endDate === null ){
                l.then(() => message.error(allStrings.completeData, 2.5) )
            }
        }
        if(hasValue(name_en)&&hasValue(description_ar)&&hasValue(description_en)){

            var data = {
                'name_en':name_en,
                'name_ar':name_ar,
                'description_ar':description_ar,
                'description_en':description_en,
                'duration':duration
            }
            if(this.state.type ==="PRIVATE"){
                data.title_en = title_en
                data.title_ar = title_ar
                if(name_en ==="EMAIL"){
                    data.name_ar ="البريد الالكترونى"
                }
                if(name_en ==="GENDER"){
                    data.name_ar ="الجنس"
                }
                if(name_en ==="IMAGE"){
                    data.name_ar ="الصوره الشخصيه "
                }
                if(name_en ==="FULLNAME"){
                    data.name_ar ="الاسم "
                }
                if(name_en ==="BIRTHDAY"){
                    data.name_ar ="تاريخ الميلاد "
                }
            }else{
                let options=[]
            if(option_ar1 !=='' && option_en1 !=='' ){
                options.push({
                  "option_ar":option_ar1,
                  "option_en":option_en1
                })
            }
            if(option_ar2 !=='' && option_en2 !=='' ){
                options.push({
                  "option_ar":option_ar2,
                  "option_en":option_en2
                })
            }
            if(option_ar3 !=='' && option_en3 !=='' ){
                options.push({
                  "option_ar":option_ar3,
                  "option_en":option_en3
                })
            }
            if(option_ar4 !=='' && option_en4 !=='' ){
                options.push({
                  "option_ar":option_ar4,
                  "option_en":option_en4
                })
            }
            if(option_ar5 !=='' && option_en5 !=='' ){
                options.push({
                  "option_ar":option_ar5,
                  "option_en":option_en5
                })
            }
            if(option_ar6 !=='' && option_en6 !=='' ){
                options.push({
                  "option_ar":option_ar6,
                  "option_en":option_en6
                })
            }
            if(options.length > 0){
                data.theOptions = options
            }
            }
            if(answerType){
                data.answerType = answerType
            }
            
            if(startDate){
                data.startDate = startDate
            }
            if(endDate){
                data.endDate = endDate
            }
            let url = `${BASE_END_POINT}questionnaires/addPrivate`
            if(this.state.type ==="PUBLIC"){
                url = `${BASE_END_POINT}questionnaires/addPublic`
            }
            console.log(data)
            axios.post(url,data,{
            headers: {
            'Content-Type': 'application/json',
            'Authorization':`Bearer ${this.props.currentUser.token}`,
            'Accept-Language':this.props.isRTL?'ar':'en'
            },
            })
            .then(response=>{
            console.log("questionnaire UPDATED  ",response.data)
            l.then(() => message.success(allStrings.done, 2.5) )
            this.props.history.goBack() 
            })
            .catch(error=>{
                console.log(error.response)
                l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
            })
        }
    }

    /**
    * form submit Handler
    */
    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.add()
    };
    /**
    * form inputs Handler
    */
    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    onChangeStartDate = (date, dateString)=>{ 
        console.log(date, dateString);
        this.setState({startDate:dateString})
    }
    onChangeEndDate = (date, dateString)=>{ 
        console.log(date, dateString);
        this.setState({endDate:dateString})
    }
    
    
  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('QUESTIONNAIRES')) return <Redirect to='/Home' />

  return (
    <div className="App">
        <MDBContainer> 
            <MDBRow>  
                <MDBCol md="12" >
                    <div className="infoCard">
                        <Card className="editCard" style={{overflow: 'visible',outline:'none',marginBottom:'0px'}}>
                        <CardMedia
                        style={{height:"0px"}}
                        />
                        <CardHeader></CardHeader>
                        <div style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                            <div className="topIcon" style={{background:'#117183'}}>
                                <span className="material-icons" style={{color:'white',fontSize:23}}>help_outline</span>
                            </div>
                            <div className="tableTitle" style={{display:this.props.isRTL?'inline-block':'inline-block',marginTop:this.props.isRTL?'-60px':'-60px',
                            marginLeft:this.props.isRTL?'0':'0rem',marginRight:this.props.isRTL?'0rem':'0'}}>
                            <p>{allStrings.addQuestionnaire}</p>
                            </div>
                        </div>
                        <CardContent style={{minHeight:"390px",outline:'none'}}>
                        <MDBContainer>
                            
                            <MDBRow>
                                <MDBCol md="12">
                                <form
                                className="needs-validation"
                                onSubmit={this.submitHandler}
                                noValidate
                                >
                                    
                                    <div className="grey-text">
                                    
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.duration}</label>
                                            <input  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.duration} type="number" min={1} id="form65" name="duration" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.type}</label>
                                            <TreeSelect 
                                                virtual={false}
                                                showSearch={false} 
                                                value={this.state.type}
                                                style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                treeCheckable = {false}         
                                                treeNodeFilterProp="title"                      
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.type}
                                                onChange={(value) => {
                                                console.log(value)
                                                this.setState({type:value});
                                                }} 
                                            >
                                                {/* <TreeNode value="PRIVATE" title={allStrings.private} key="PRIVATE" /> */}
                                                <TreeNode value="PUBLIC" title={allStrings.public} key="PUBLIC" />          
                                                
                                                
                                            </TreeSelect>
                                        </MDBCol>
                                        
                                    </MDBRow>
                                    {this.state.type ==="PRIVATE"&&
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form82" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishTitle}</label>
                                            <input  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.title_en} type="text" id="form82" name="title_en" className="form-control" validate onChange={this.changeHandler} required/>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form806" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicTitle}</label>
                                            <input onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') }  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.title_ar} type="text" id="form806" name="title_ar"className="form-control" validate onChange={this.changeHandler} required/>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.type ==="PRIVATE"?
                                    <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                        <MDBCol md="12">
                                            <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.questionnaireOn}</label>
                                            <TreeSelect 
                                                virtual={false}
                                                showSearch={false} 
                                                style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                treeCheckable = {false}         
                                                treeNodeFilterProp="title"                      
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.questionnaireOn}
                                                onChange={(value) => {
                                                console.log(value)
                                                this.setState({name_en:value});
                                                }} 
                                            >
                                                <TreeNode value="EMAIL" title={allStrings.email} key="EMAIL" />
                                                <TreeNode value="FULLNAME" title={allStrings.name} key="FULLNAME" />
                                                <TreeNode value="GENDER" title={allStrings.gender} key="GENDER" />
                                                <TreeNode value="BIRTHDAY" title={allStrings.birthday} key="BIRTHDAY" />
                                                <TreeNode value="IMAGE" title={allStrings.profileImg} key="IMAGE" />            
                                                
                                                
                                            </TreeSelect>
                                        </MDBCol>
                                    </MDBRow>
                                    :
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishName}</label>
                                            <input onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') }  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.name_en} type="text" id="form645" name="name_en" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form56" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicName}</label>
                                            <input onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.name_ar} type="text" id="form56" name="name_ar" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    <MDBRow>
                                      <MDBCol md="12">
                                        <div className="md-form">
                                          <label htmlFor="form920" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishDescription}</label>
                                          <br></br>
                                          <textarea  onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') } name="description_en" onChange={this.changeHandler} value={this.state.description_en} style={{border:'none',borderBottom:'1px solid #dededede',direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 7px'}} type="text" id="form920" className="form-control" required validate   />
                                          <div class="valid-feedback">{allStrings.correct}</div>
                                          <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                      </MDBCol>
                                      
                                    </MDBRow>
                                    <MDBRow>
                                      <MDBCol md="12">
                                        <div className="md-form">
                                          <label htmlFor="form920" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicDescription}</label>
                                          <br></br>
                                          <textarea  onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') } name="description_ar" onChange={this.changeHandler} value={this.state.description_ar} style={{border:'none',borderBottom:'1px solid #dededede',direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 7px'}} type="text" id="form920" className="form-control" required validate   />
                                          <div class="valid-feedback">{allStrings.correct}</div>
                                          <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                      </MDBCol>
                                      
                                    </MDBRow>
                                    
                                    {this.state.type ==="PUBLIC"&&
                                    <MDBRow style={{flexFlow:this.props.isRTL?'row-reverse':'row'}}  >
                                        <MDBCol md="6">
                                        <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.startDate}</label>
                                        <DatePicker  style={{width:'100%'}} placeholder={allStrings.startDate} onChange={this.onChangeStartDate} />
                                        </MDBCol>
                                        <MDBCol md="6">
                                        <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.endDate}</label>
                                        <DatePicker  style={{width:'100%'}} placeholder={allStrings.endDate} onChange={this.onChangeEndDate}  />
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.type ==="PUBLIC"&&
                                    <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                        <MDBCol md="12">
                                            <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.answerType}</label>
                                            <TreeSelect 
                                                virtual={false}
                                                showSearch={false} 
                                                style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                treeCheckable = {false}         
                                                treeNodeFilterProp="title"                      
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.answerType}
                                                onChange={(value) => {
                                                console.log(value)
                                                this.setState({answerType:value});
                                                }} 
                                            
                                            >
                                                <TreeNode value="CHOOSE-ONE" title={allStrings.chooseOne} key="CHOOSE-ONE" />
                                                <TreeNode value="CHOOSE-MULTIPLE" title={allStrings.chooseMultiple} key="CHOOSE-MULTIPLE" />
                                                <TreeNode value="ARTICLE" title={allStrings.article} key="ARTICLE" />
                                                
                                                
                                            </TreeSelect>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.inputCount > 0&& this.state.type ==="PUBLIC" &&
                                    <MDBRow>
                                        <MDBCol md="1">
                                        {this.state.inputCount === 0 &&
                                        <div className="minusInput" onClick={()=>this.setState({inputCount:this.state.inputCount - 1})}>
                                        <MDBIcon icon="trash" className="mr-2" />           
                                        </div>
                                        }
                                        </MDBCol>
                                        <MDBCol md="5">
                                        <div className="md-form">
                                            <label htmlFor="form2" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicOptionName}</label>
                                            <input onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') }  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.option_ar} type="text" id="form2" name="option_ar1" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form21" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishOptionName}</label>
                                                <input onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') }  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.option_en} type="text" id="form21" name="option_en1" className="form-control" onChange={this.changeHandler} required validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.inputCount > 1&&this.state.type ==="PUBLIC" &&
                                    <MDBRow>
                                        <MDBCol md="1">
                                        {this.state.inputCount === 2 &&
                                        <div className="minusInput" onClick={()=>this.setState({inputCount:this.state.inputCount - 1})}>
                                        <MDBIcon icon="trash" className="mr-2" />           
                                        </div>
                                        }
                                        </MDBCol>
                                        <MDBCol md="5">
                                        <div className="md-form">
                                            <label htmlFor="form22" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicOptionName}</label>
                                            <input  onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.option_ar2} type="text" id="form22" name="option_ar2" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form221" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishOptionName}</label>
                                                <input  onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.option_en2} type="text" id="form221" name="option_en2" className="form-control" onChange={this.changeHandler} required validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.inputCount > 2&&this.state.type ==="PUBLIC" &&
                                    <MDBRow>
                                        <MDBCol md="1">
                                        {this.state.inputCount === 3 &&
                                        <div className="minusInput" onClick={()=>this.setState({inputCount:this.state.inputCount - 1})}>
                                        <MDBIcon icon="trash" className="mr-2" />           
                                        </div>
                                        }
                                        </MDBCol>
                                        <MDBCol md="5">
                                        <div className="md-form">
                                            <label htmlFor="form22" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicOptionName}</label>
                                            <input  onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.option_ar2} type="text" id="form22" name="option_ar2" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form221" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishOptionName}</label>
                                                <input  onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.option_en2} type="text" id="form221" name="option_en2" className="form-control" onChange={this.changeHandler} required validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.inputCount > 3&&this.state.type ==="PUBLIC" &&
                                    <MDBRow>
                                        <MDBCol md="1">
                                        {this.state.inputCount === 4 &&
                                        <div className="minusInput" onClick={()=>this.setState({inputCount:this.state.inputCount - 1})}>
                                        <MDBIcon icon="trash" className="mr-2" />           
                                        </div>
                                        }
                                        </MDBCol>
                                        <MDBCol md="5">
                                        <div className="md-form">
                                            <label htmlFor="form232" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicOptionName}</label>
                                            <input   onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') }style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.option_ar3} type="text" id="form232" name="option_ar3" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form231" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishOptionName}</label>
                                                <input  onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.option_en3} type="text" id="form231" name="option_en3" className="form-control" onChange={this.changeHandler} required validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.inputCount > 4&&this.state.type ==="PUBLIC" &&
                                    <MDBRow>
                                        <MDBCol md="1">
                                        {this.state.inputCount === 5 &&
                                        <div className="minusInput" onClick={()=>this.setState({inputCount:this.state.inputCount - 1})}>
                                        <MDBIcon icon="trash" className="mr-2" />           
                                        </div>
                                        }
                                        </MDBCol>
                                        <MDBCol md="5">
                                        <div className="md-form">
                                            <label htmlFor="form242" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicOptionName}</label>
                                            <input   onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') }style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.option_ar4} type="text" id="form242" name="option_ar4" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form241" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishOptionName}</label>
                                                <input  onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.option_en4} type="text" id="form241" name="option_en4" className="form-control" onChange={this.changeHandler} required validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.inputCount > 5&&this.state.type ==="PUBLIC" &&
                                    <MDBRow>
                                        <MDBCol md="1">
                                        {this.state.inputCount === 6 &&
                                        <div className="minusInput" onClick={()=>this.setState({inputCount:this.state.inputCount - 1})}>
                                        <MDBIcon icon="trash" className="mr-2" />           
                                        </div>
                                        }
                                        </MDBCol>
                                        <MDBCol md="5">
                                        <div className="md-form">
                                            <label htmlFor="form252" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicOptionName}</label>
                                            <input   onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') }style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.option_ar5} type="text" id="form252" name="option_ar5" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form251" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishOptionName}</label>
                                                <input  onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.option_en5} type="text" id="form251" name="option_en5" className="form-control" onChange={this.changeHandler} required validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.inputCount > 6&&this.state.type ==="PUBLIC" &&
                                    <MDBRow>
                                        <MDBCol md="1">
                                        {this.state.inputCount === 7 &&
                                        <div className="minusInput" onClick={()=>this.setState({inputCount:this.state.inputCount - 1})}>
                                        <MDBIcon icon="trash" className="mr-2" />           
                                        </div>
                                        }
                                        </MDBCol>
                                        <MDBCol md="5">
                                        <div className="md-form">
                                            <label htmlFor="form262" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicOptionName}</label>
                                            <input   onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') }style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.option_ar6} type="text" id="form262" name="option_ar6" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                                <label htmlFor="form261" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishOptionName}</label>
                                                <input  onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.option_en6} type="text" id="form261" name="option_en6" className="form-control" onChange={this.changeHandler} required validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.inputCount < 6 && this.state.type==="PUBLIC"&&
                                    <MDBRow>
                                        <div className="addInput" onClick={()=>this.setState({inputCount:this.state.inputCount + 1})}>
                                        <MDBIcon icon="plus" className="mr-2" />           
                                        </div>
                                    </MDBRow>
                                    
                                    }
                                    
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <div className="text-center">
                                    <MDBBtn
                                        style={{background:'#117183',color:'#fff'}}
                                        rounded
                                        type="submit"
                                        color="#117183"
                                        className="btn-block z-depth-1a"
                                        >
                                        <MDBIcon icon="plus" className="mr-2" />
                                            {allStrings.add}          
                                    </MDBBtn>
                                        
                                        
                                    </div>
                                </form>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                        </CardContent>
                    </Card>
                </div>
            </MDBCol> 
            </MDBRow>
      </MDBContainer>
      
    </div> 
  )
  }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
  });
  
  const mapDispatchToProps = {
  };
  
  export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(AddQuestionnaire)
  );